import type { OpeningGroupListItem } from "~/lib/openingGroups";
import type { HomeOpeningGroupSelection } from "./home-opening-group-selection";
import { cn } from "~/lib/utils";

type HomeOpeningGroupControlProps = {
  groups: readonly OpeningGroupListItem[];
  value: HomeOpeningGroupSelection | null;
  onValueChange: (value: HomeOpeningGroupSelection) => void;
  disabled?: boolean;
};

export default function HomeOpeningGroupControl({
  groups,
  value,
  onValueChange,
  disabled = false,
}: HomeOpeningGroupControlProps) {
  const options: Array<{
    key: string;
    label: string;
    value: HomeOpeningGroupSelection;
  }> = [
    { key: "tasks", label: "Задачи", value: { kind: "tasks" } },
    ...groups.map((group) => ({
      key: `opening-group:${group.problemSetId}`,
      label: group.name,
      value: {
        kind: "opening-group" as const,
        problemSetId: group.problemSetId,
      },
    })),
  ];

  return (
    <div
      role="group"
      aria-label="Разделы"
      className="inline-flex w-fit flex-wrap items-center justify-center gap-1 rounded-lg border bg-muted/40 p-1"
    >
      {options.map((option) => {
        const selected =
          value?.kind === option.value.kind &&
          (value.kind === "tasks" ||
            (option.value.kind === "opening-group" &&
              value.problemSetId === option.value.problemSetId));
        return (
          <button
            key={option.key}
            type="button"
            aria-pressed={selected}
            disabled={disabled}
            onClick={() => onValueChange(option.value)}
            className={cn(
              "max-w-full whitespace-normal break-words rounded-md px-3 py-1.5 text-sm font-medium transition-colors disabled:cursor-not-allowed disabled:opacity-60",
              selected
                ? "bg-background text-foreground shadow-sm"
                : "text-muted-foreground hover:bg-background/70 hover:text-foreground",
            )}
          >
            {option.label}
          </button>
        );
      })}
    </div>
  );
}
